import styled from 'styled-components';

export const Caption = styled.p`
  margin: ${props => props.theme.spacing(3, 0)};
  ${props => props.theme.typography.body}
`;

export const StyledQuestion = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(4)};
  margin-bottom: ${props => props.theme.spacing(6)};
  text-align: center;
  width: 100%;

  h2 {
    ${props => props.theme.fontFamily.base}
    margin-bottom: ${props => props.theme.spacing(5)};
  }
`;
